export class MenuItem {
  constructor(public path: string, public icon: string, public label: string, public roles: string[]) {}
}
